<sag-ui-button color="tertiary" [icon]="'notification'" [square]="true" (click)="toggleView()">
  @if (unreadMessages) {
    <span class="unread-messages">{{ unreadMessages }}</span>
  }
</sag-ui-button>

@if (isVisible) {
  <div class="communication-container">
    @if (IS_TRS_PROJECT) {
      <div class="communication-header">Notifications</div>
    } @else if (IS_PRODUCT_SAFETY_PROJECT) {
      <div class="communication-header">Benachrichtigungen</div>
    }
    <sag-ui-tabview>
      <sag-ui-tab [label]="IS_TRS_PROJECT ? 'All' : 'Alle'" (click)="type = 'all'; loadData()"></sag-ui-tab>
      <sag-ui-tab [label]="'Tasks'" (click)="type = 'task'; loadData()"></sag-ui-tab>
    </sag-ui-tabview>
    <div class="scroll-container">
      @if (pagedData?.items) {
        @if (pagedData?.totalItems !== 0) {
          @for (item of paginatedData; track item) {
            <app-communication-item [item]="item" />
          }
        } @else {
          @for (item of placeholderArray; track item.id) {
            <app-communication-item [isPlaceholder]="true" [item]="item.report" />
          }
        }
      }
    </div>
  </div>
  <div (click)="toggleView()" class="notification-backdrop"></div>
}
